<template lang="pug">
.modal.is-active(v-if="loadingIsLoading")
  .modal-background
  .modal-content.has-text-centered
    button.button.is-loading.is-primary
</template>

<script>
import LoadingMixin from '@/mixins/LoadingMixin.vue'

export default {
  mixins: [
    LoadingMixin
  ]
}
</script>
